import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Badges } from '../../../../AbstractElements';
import { ContextualVariations, Danger, Dark, Info, Light, Primary, secondary, Success, Warning } from '../../../../Constant';
import HeaderCard from '../../../Common/HeaderCard';

const ContextualPills = () => {
  return (
    <Col sm='12' xl='6'>
      <Card>
        <HeaderCard title={ContextualVariations} />
        <CardBody>
          <Badges  className= 'badge rounded-pill' color= 'primary' pill= {true} >{Primary}</Badges>
          <Badges  className= 'badge rounded-pill' color= 'secondary' pill= {true} >{secondary}</Badges>
          <Badges  className= 'badge rounded-pill' color= 'success' pill= {true} >{Success}</Badges>
          <Badges  className= 'badge rounded-pill' color= 'info' pill= {true}>{Info}</Badges>
          <Badges  className= 'badge rounded-pill text-dark' color= 'warning' pill= {true}>{Warning}</Badges>
          <Badges  className= 'badge rounded-pill' color= 'danger' pill= {true }>{Danger}</Badges>
          <Badges  className= 'badge rounded-pill text-dark' color= 'light' pill= {true} >{Light}</Badges>
          <Badges  className= 'badge rounded-pill' color= 'dark tag-pills-sm-mb' pill= {true} >{Dark}</Badges>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ContextualPills;
